import { CalendarEventsTable } from '../components/dashboard/CalendarEventsTable';
import { DashboardCharts } from '../components/dashboard/DashboardCharts';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardKPIs } from '../components/dashboard/DashboardKPIs';
import { IntelligentFilterBar } from '../components/dashboard/IntelligentFilterBar';
import { RecentTransactionsTable } from '../components/dashboard/RecentTransactionsTable';
import { OverduePaymentsWidget } from '../components/payment-plans/OverduePaymentsWidget';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { useDashboardData } from '../hooks/useDashboardData';
import { useDashboardFilters } from '../hooks/useDashboardFilters';

export function DashboardPage() {
  const filters = useDashboardFilters();
  const {
    filteredBookings,
    allBookings,
    uniqueSpaceNames,
    kpis,
    pieData,
    revenueTrendData,
    topSpacesData,
    loading,
    error,
  } = useDashboardData(filters);

  if (loading) {
    return <LoadingSpinner message="Chargement du dashboard" />;
  }

  if (error) {
    return (
      <div className="space-y-6 pb-12">
        <DashboardHeader />
        <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
          <p className="text-red-600 font-medium mb-2">Erreur lors du chargement</p>
          <p className="text-red-500 text-sm">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-12">
      <DashboardHeader />

      <IntelligentFilterBar
        dateFilter={filters.dateFilter}
        typeFilter={filters.typeFilter}
        statusFilter={filters.statusFilter}
        updateFilter={filters.updateFilter}
        hasActiveFilters={filters.hasActiveFilters}
        resetFilters={filters.resetFilters}
        filteredBookingsCount={filteredBookings.length}
        totalBookingsCount={allBookings.length}
        uniqueSpaceNames={uniqueSpaceNames}
      />

      <DashboardKPIs kpis={kpis} totalBookings={allBookings.length} />

      <OverduePaymentsWidget />

      <DashboardCharts revenueTrendData={revenueTrendData} pieData={pieData} topSpacesData={topSpacesData} />

      <RecentTransactionsTable
        filteredBookings={filteredBookings}
        hasActiveFilters={filters.hasActiveFilters}
        resetFilters={filters.resetFilters}
      />

      <CalendarEventsTable />
    </div>
  );
}
